export const checkboxItemAll = 'all'
export const checkboxItemUnread = 'unread'
